import CookieBarController from 'controllers/cookie-bar_controller'

Stimulus.register('cookie-bar', CookieBarController)
